import type React from "react";

type Props = {
	children: React.ReactNode;
};

/**
 *
 * Features の UI で定義される Island デザインを定義するコンテナ
 * example では、`FeatureIslandHeader`, `FeatureIslandMain`, `FeatureIslandMainWithCategory` を子要素として受け取っているが直接的な依存関係はない。
 * ただし、統一を図るために example のような構成を想定している。
 *
 * @example 純粋な構成
 * ```
 * <FeatureIslandContainer>
 *   <FeatureIslandHeader />
 *   <FeatureIslandMain>
 *     {children}
 *   </FeatureIslandMain>
 * </FeatureIslandContainer>
 * ```
 * @example カテゴリーを持つ構成
 * ```
 * <FeatureIslandContainer>
 *   <FeatureIslandHeader />
 *   <FeatureIslandMainWithCategory categoryManagerStore={store}>
 *     {children}
 *   </FeatureIslandMainWithCategory>
 * </FeatureIslandContainer>
 * ```
 */
export const FeatureIslandContainer = ({ children }: Props) => children;
